module.exports = __webpack_public_path__ + "static/media/Gary Li's Resume.bbb1818d.pdf";